import { PageProps, graphql } from 'gatsby';

import React from 'react';
import Layout from '../components/layouts/Layout';
import NotFoundScreen from '../components/screens/NotFoundScreen/NotFoundScreen';
import { StoreLocatorProvider } from '../components/StoreLocator';
import { CMSPageData } from '../ContentfulTypes';
import { GatsbyPageContextProps } from '../types';

const NotFoundPage = ({
  pageContext,
  data,
  location,
}: PageProps<CMSPageData, GatsbyPageContextProps>) => (
  <StoreLocatorProvider>
    <Layout locale={pageContext.locale} location={location}>
      <NotFoundScreen
        contentfulData={data.contentfulPage}
      />
    </Layout>
  </StoreLocatorProvider>
);

// ts-prune-ignore-next
export const query = graphql`
  query page404($formattedLocale: String = "en-CA") {
    contentfulPage(
      contentful_id: { eq: "1321EF2CdWoBGyVvAVOdeW" }
      node_locale: { eq: $formattedLocale }
    ) {
      contentful_id
      node_locale
      metaDescription {
        metaDescription
      }
      metaTitle
      contentful_id
      pageSections {
        ... on ContentfulImageSection {
          id
          backgroundImageDesktop {
            id
            altText
            asset {
              url
              localImage {
                id
                publicURL
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
          foregroundImageDesktop {
            id
            altText
            asset {
              url
              localImage {
                id
                publicURL
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
          imageDescription {
            id
            heading {
              raw
            }
            subHeading {
              raw
            }
            contentBody {
              raw
              references {
                ... on ContentfulCta {
                  id
                  contentful_id
                  ctaColor
                  ctaTarget
                  ctaType
                  ctaUrl
                  ctaLabel {
                    ctaLabel
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default NotFoundPage;
